import {TokenCredentials} from '../login/tokencredentials';
import {Vendor} from '../vendor/vendor';

export class Receipt {
    credentials : TokenCredentials;

    id : number;
    version : number;
    userid : number;
    receipt : string;
    hint : string;
    gate : string;
    vendorid : number;
    state : number;
    created : Date;
    updated : Date;
    started : Date;
    finished : Date;

    positions : ReceiptPos [];
}

export class ReceiptPos {
    constructor () {
        this.qtyExpected = 0;
        this.qtyReceived = 0;
    }
    id : number;
    version : number;
    userid : number;
    receipt : string;
    pos : string;
    articleid : number;
    qtyExpected : number;
    qtyReceived : number;
    reservationCode : string;
    state : number;
    created : Date;
    updated : Date;
    started : Date;
    finished : Date;
}

export class ReceiptListItem {
    id : number;
    receipt : string;
    hint : string;
    gate : string;
    vendor : Vendor;
    positionslength: number;
    state : number;
}


// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/receipt/receipt.ts